import { JournalEntriesTable as SharedJournalEntriesTable } from '@vrplatform/embed';
import { utc } from '@vrplatform/utils';
import type { ComponentProps } from 'react';
import { useNavigate } from 'react-router';
import {
  useBankTransferDetailDrawer,
  useDepositDetailDrawer,
  useExpenseDetailDrawer,
  useOwnerDetailDrawer,
  usePayoutDetailDrawer,
  useReservationDetailDrawer,
} from '../../drawers';
type Props = Omit<ComponentProps<typeof SharedJournalEntriesTable>, 'actions'>;

export const JournalEntriesTable = ({
  queryData,
  filterProps,
  children,
}: Props) => {
  'use memo';

  const { open: openReservation } = useReservationDetailDrawer();
  const { open: openExpenseDrawer } = useExpenseDetailDrawer();
  const { open: openDepositDrawer } = useDepositDetailDrawer();
  const { open: openOwnerDrawer } = useOwnerDetailDrawer();
  const { open: openPayoutDrawer } = usePayoutDetailDrawer();
  const { open: openTransferDrawer } = useBankTransferDetailDrawer();
  const navigate = useNavigate();

  return (
    <SharedJournalEntriesTable
      actions={{
        onGoToOpeningBalances: () =>
          navigate('/settings/accounting/opening-balances'),
        onOpenDeposit: (transactionId) =>
          openDepositDrawer(transactionId, 'push'),
        onOpenExpense: (transactionId) =>
          openExpenseDrawer(transactionId, 'push'),
        onOpenOwner: openOwnerDrawer,
        onOpenOwnerStatement: ({
          currency,
          listingOwnershipPeriodId,
          startAt,
        }) => {
          if (!currency || !listingOwnershipPeriodId) return;

          navigate(
            `/statement/${listingOwnershipPeriodId}?date=${utc(startAt).format(
              'YYYY-MM-DD'
            )}&cur=${currency}`
          );
        },
        onOpenPayout: (transactionId) =>
          openPayoutDrawer(transactionId, 'push'),
        onOpenReservation: (reservationId) =>
          openReservation(reservationId, 'overview', 'push'),
        onOpenTransfer: (transactionId) =>
          openTransferDrawer(transactionId, 'push'),
      }}
      queryData={queryData}
      filterProps={filterProps}
    >
      {children}
    </SharedJournalEntriesTable>
  );
};
